/* Block - Full-width Feature.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-full-feature.scss";
import videoControls from "../../js/component/_video-controls.js";

videoControls.init('.rs-video .rs-play', '.embed-container .rs-play');